import { createContainer } from 'react-sweet-state';
import type { State } from './types';

export const ConversationStateContainer = createContainer<{
    conversationProvider: State['conversationProvider'];
}>();
